/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MatchBetVoting = {
    properties: {
        voting1: {
            type: 'number',
            isRequired: true,
        },
        voting2: {
            type: 'number',
            isRequired: true,
        },
        'x': {
            type: 'number',
            isRequired: true,
        },
        userVoting: {
            type: 'any-of',
            contains: [{
                type: 'MatchLocationEnum',
            }, {
                type: 'null',
            }],
        },
    },
} as const;
